import React from 'react';
import { AsyncComboboxAutocomplete, InputParams, isReddit } from '@aleph/shared-components';
import { AgencyAccessOptionsQueryUsersUsers, AgencyAccessOptionsQueryItems } from 'wb-reddit/graphql/generated';
import { AuthGraphSearchOwnerQueryItems } from 'wb-spotify/graphql/authgraph/generated';
import { MutatingAdvertiser } from 'wb-reddit/app/routes/advertisers/hooks/useRedditAdvertiserMutator';
import { ComboboxAutocompleteOption } from 'wb-reddit/app/common/components/comboboxAutocompleteOption';
import { useTranslation } from 'react-i18next';

type Option = AgencyAccessOptionsQueryItems | AgencyAccessOptionsQueryUsersUsers | AuthGraphSearchOwnerQueryItems;

interface IProps {
	loadOptions: (search: string) => Promise<Option[]>
	values: MutatingAdvertiser
	onOptionClick: (option: Option) => void
	disabled?: boolean
	triggerProps?: InputParams
	setTouched: () => void
}

function AdvertisterOwnerAutocomplete({
	loadOptions, values, onOptionClick,
	disabled, triggerProps, setTouched,
}: IProps) {
	const { t } = useTranslation();

	return (
		<div>
			<AsyncComboboxAutocomplete
				inputProps={{
					...triggerProps,
					placeholder:     t('re: owner autocomplete placeholder', 'Owner'),
					label:           t('re: owner autocomplete placeholder', 'Owner'),
					instructionText: t('re: owner autocomplete role', 'Only users with an Advertiser Admin role can be assigned as owners.'),
					onClick:         setTouched,
				}}
				hideSearchIcon
				hideSelectedOptionWhenMenuIsOpen
				size="small"
				// @ts-ignore
				loadOptions={loadOptions}
				renderOption={({ option, searchQuery, onSelected }) => (
					<ComboboxAutocompleteOption
						option={option}
						// @ts-ignore
						onOptionClick={onOptionClick}
						onSelected={onSelected}
						searchQuery={searchQuery}
					/>
				)}
				// @ts-ignore
				selectedOptions={
					values.agencyAccountOwner
						? [{
							...values.agencyAccountOwner,
							value: values.agencyAccountOwner.userId,
							label: isReddit()
								? values.agencyAccountOwner.userFullName
								// @ts-ignore
								: `${values.agencyAccountOwner.userName} ${values.agencyAccountOwner.userSurname || ''}`,
						}]
						: []
				}
				SelectedOptionComponent={values.agencyAccountOwner?.userEmail ?? null}
				NoOptionsComponent={() => (
					<div className='max-w-[25vw] w-fit'>
						<strong>{t('re: full email', 'Use full email address to find a user')}</strong>
					</div>
				)}
				disabled={disabled}
			/>
		</div>
	);
}

export default AdvertisterOwnerAutocomplete;
